module.exports = __webpack_public_path__ + "img/mhLandingBanner.2b61144.webp";